<img
    [src]="source()"
    [alt]="alternativeText()"
    draggable="false"
    [style.width]="width()"
    [style.max-width]="maxWidth()"
    [style.max-height]="maxHeight()"
    [style.object-fit]="objectFit()"
    [style.aspect-ratio]="aspectRatio()"
    [style.--preview-image-rotation]="`${rotation()}deg`"
    (load)="viewerLoaded.emit()"
    (error)="viewerLoadError.emit($event)"
/>
